export function ActionFormContent({ direction = 'vertical', children }) {
    return (
        <div className={direction === 'vertical' ? 'content' : 'content horizontal'}>
            {children}
        </div>
    );
}
